import { render, staticRenderFns } from "./UpdateRoleAuthModal.vue?vue&type=template&id=53d3b4e5&scoped=true"
import script from "./UpdateRoleAuthModal.vue?vue&type=script&lang=js"
export * from "./UpdateRoleAuthModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateRoleAuthModal.vue?vue&type=style&index=0&id=53d3b4e5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d3b4e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53d3b4e5')) {
      api.createRecord('53d3b4e5', component.options)
    } else {
      api.reload('53d3b4e5', component.options)
    }
    module.hot.accept("./UpdateRoleAuthModal.vue?vue&type=template&id=53d3b4e5&scoped=true", function () {
      api.rerender('53d3b4e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/system/components/Modal/UpdateRoleAuthModal.vue"
export default component.exports